import { render } from "./BaseButton.vue?vue&type=template&id=1a014151&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=1a014151&scoped=true&lang=css"

import exportComponent from "D:\\Shehab\\Coding\\vue\\Maxmillian\\Vue-The-Complete-Guide\\lec 18\\deploy01-starting-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a014151"]])

export default __exports__